var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 319.73 250.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#020288;}.cls-2{fill:#fff59b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m271.34,72.33c-37.03.14-74.07.08-111.1.08s-74.57.05-111.85-.08c-3.65-.01-4.51,1.04-4.5,4.59.12,42.27.08,84.55.08,126.82q0,4.9,5.04,4.9c73.82,0,147.64-.04,221.46.12,4.14,0,5.16-1.63,5.28-5.02.03-.75.01-1.5.01-2.24,0-41.52-.04-83.05.08-124.57.01-3.55-.84-4.61-4.5-4.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 102.04,
    y: 112.95,
    width: 115.65,
    height: 17.01,
    rx: 8.5,
    ry: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.45,
    y: 146.97,
    width: 74.83,
    height: 17.01,
    rx: 8.5,
    ry: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m287.28,250.28H32.45c-17.92,0-32.45-14.53-32.45-32.45V32.45C0,14.53,14.53,0,32.45,0h61.7c7.09,0,13.66,3.74,17.28,9.85l10.24,17.29c1.28,2.16,3.6,3.48,6.11,3.48h159.5c17.92,0,32.45,14.53,32.45,32.45v154.77c0,17.92-14.53,32.45-32.45,32.45ZM32.45,10.47c-12.14,0-21.98,9.84-21.98,21.98v185.39c0,12.14,9.84,21.98,21.98,21.98h254.83c12.14,0,21.98-9.84,21.98-21.98V63.06c0-12.14-9.84-21.98-21.98-21.98H121.82c-2.51,0-4.83-1.32-6.11-3.48l-10.24-17.29c-3.62-6.1-10.18-9.85-17.28-9.85h-55.74Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/icon-archive.9497e63f7f1fa277b41e8251eac9e6f5.svg";
export { ForwardRef as ReactComponent };